/**
 * Country flags, one SVG per country, named by its ISO 3166-1 alpha-2 code in
 * lower case (`gb.svg`, `sa.svg`). A file dropped into this folder is picked up
 * on the next build; nothing else has to be registered.
 */
const urlsByPath = import.meta.glob<string>('./*.svg', { eager: true, query: '?url', import: 'default' });

const FLAG_URLS: Record<string, string> = Object.fromEntries(
  Object.entries(urlsByPath).map(([path, url]) => [path.slice('./'.length, -'.svg'.length), url])
);

export const getFlagUrl = (country: string): string | undefined => FLAG_URLS[country.toLowerCase()];
